/* istanbul ignore file */
import React from 'react';
import { Grid2 as Grid } from '@mui/material';
import { NumberInput, TextInput } from 'framework/form';
import RemoveListItemButton from 'domain/projects/project/weeklyreports/shared/button/RemoveListItemButton';
import useInputRow from './useInputRow';
import type { PlannedItemType } from './inputTypes';

interface PlannedItemInputRowProps {
  data: PlannedItemType;
  id: number;
  formData: any;
  updateFormData: (source: string, newFormData: any) => void;
}

export const getPlannedItemsSource = (id: number) => {
  return `weeklyReportData.plannedItems[${id}]`;
};

const PlannedItemInputRow = ({ data, formData, id, updateFormData }: PlannedItemInputRowProps) => {
  const source = getPlannedItemsSource(id);
  const { getOnChangeCallback, removeRow } = useInputRow({
    data,
    source,
    formData,
    id,
    updateFormData,
    listSource: 'plannedItems',
  });

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, md: 1 }}>
        <NumberInput source={`${source}.id`} value={data.id} label={id === 0 ? 'ID' : ''} disabled isRequired />
      </Grid>
      <Grid size={{ xs: 12, md: 10 }}>
        <TextInput
          source={`${source}.description`}
          value={data.description}
          label={id === 0 ? 'Description' : ''}
          onChangeCallback={getOnChangeCallback('description')}
          isRequired
        />
      </Grid>
      <Grid size={{ xs: 12, md: 1 }}>
        <RemoveListItemButton isVisible onClickCallback={removeRow} isFirstRow={id === 0} />
      </Grid>
    </Grid>
  );
};

export default PlannedItemInputRow;
